import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

import './index.css';

window.render = function( config, callback ) {
    if( !config ) {
        throw new Error('spinToWin: config object not set')
    }

    ReactDOM.render(<App config={ config } />, document.getElementById('root'), callback);
}


// WEBPACK FOOTER //
// ./src/index.js